import React, { Component } from 'react';

const seconds = 30;

export default class Countdown extends Component {
  state = {
    seconds: seconds,
    isRunning: this.props.active,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let toState = {};
    let { active } = nextProps;

    toState = {
      ...toState,
      isRunning: active,
    };
    if (!active) {
      toState = {
        ...toState,
        seconds,
      };
    }
    return toState;
  }

  componentDidMount() {
    this.start();
  }

  // componentDidUpdate() {
  // 	const { onChange } = this.props;
  // 	const { isRunning } = this.state;
  // }

  componentWillUnmount() {
    this.stop();
  }

  start() {
    const { onChange } = this.props;
    onChange(true);
    this.timer = setInterval(() => {
      this.setState(prev => ({
        seconds: prev.seconds > 0 ? prev.seconds - 1 : 0,
        isRunning: prev.seconds !== 0,
      }));
      const { seconds } = this.state;
      if (seconds === 0) {
        onChange(false);
      }
    }, 1000);
  }

  stop() {
    clearInterval(this.timer);
  }

  addZeros(value) {
    value = String(value);
    if (value.length < 2) {
      value = '0' + value;
    }
    return value;
  }

  render() {
    let { seconds, isRunning } = this.state;
    // let btnClasses = isRunning ? 'link-btn disabled' : 'link-btn';
    return (
      <div>
        {/* <div>
					<button className={btnClasses} onClick={this.props.clicked}>
						Отправить код повторно
					</button>
				</div> */}
        {isRunning ? (
          <span className="countDown" style={{ userSelect: 'none' }}>
            {/*<span*/}
            {/*  onClick={() => this.props.clicked}*/}
            {/*  style={{ cursor: 'pointer' }}*/}
            {/*>*/}
            {/*  Отправить код повторно*/}
            {/*</span>*/}
            {/*<br />*/}(Через {this.addZeros(seconds)} секунд)
          </span>
        ) : null}
      </div>
    );
  }
}
